import { type JSM_ORGANIZATION_GQL_FIELD, ORGANIZATIONS_CF_TYPE, PLAIN_TEXT } from '../constants';
import type { AggTransformerFunction } from '../types';
import { transformAggConnection, transformAggNodeToLegacyField } from './default-node-transformer';

export const transformAggJSMOrganizationToLegacyField: AggTransformerFunction<
	typeof JSM_ORGANIZATION_GQL_FIELD
> = (node) => {
	if (node.type !== ORGANIZATIONS_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: transformAggConnection(node.selectedOrganizationsConnection, (selectedNode) => ({
			id: selectedNode.organizationId,
			name: selectedNode.organizationName,
		})),
		schema: {
			configuration: null,
			custom: ORGANIZATIONS_CF_TYPE,
			items: 'sd-customerorganization',
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
